webpackJsonp([114276838955818,60335399758886],{

/***/ 122:
/***/ (function(module, exports) {

	module.exports = {"data":{"contentfulLayout":{"navigation":[{"title":"Home","url":"/"},{"title":"Portfolio","url":"/portfolio"}],"socialMedia":[{"network":"linkedin","url":"https://www.linkedin.com/in/dougmacklin"},{"network":"github","url":"https://github.com/dougmacklin"},{"network":"stack-overflow","url":"https://stackoverflow.com/users/1179207/dougmacklin"},{"network":"twitter","url":"https://twitter.com/dougmacklin"}]}},"layoutContext":{}}

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(255);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(122);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  siteTitle: 'Doug Macklin',
	  siteTitleAlt: 'Doug Macklin',
	  siteLogo: '',
	  siteDescription: 'Full Stack Web Developer',
	  siteUrl: 'https://dougmacklin.com',
	  userTwitter: '@dougmacklin',
	  siteFBAppID: null,
	  googleAnalyticsID: 'UA-38112456-2'
	};

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _socialModule = __webpack_require__(347);
	
	var _socialModule2 = _interopRequireDefault(_socialModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var socialMedia = _ref.socialMedia;
	  return _react2.default.createElement(
	    'div',
	    null,
	    socialMedia.map(function (_ref2, index) {
	      var url = _ref2.url,
	          network = _ref2.network;
	      return _react2.default.createElement(
	        'a',
	        {
	          href: url,
	          target: '_blank',
	          className: _socialModule2.default.account,
	          key: index
	        },
	        _react2.default.createElement('i', { className: 'fa fa-' + network })
	      );
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 347:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"account":"src-components----social-module---account---3JbSr"};

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(74);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _social = __webpack_require__(254);
	
	var _social2 = _interopRequireDefault(_social);
	
	var _config = __webpack_require__(253);
	
	var _indexModule = __webpack_require__(348);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	__webpack_require__(500);
	
	__webpack_require__(501);
	
	__webpack_require__(350);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_Component) {
	  _inherits(_class, _Component);
	
	  function _class(props) {
	    _classCallCheck(this, _class);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = { menuOpen: false, scrolled: false };
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    return _this;
	  }
	
	  _class.prototype.closeMenu = function closeMenu() {
	    this.setState({ menuOpen: false });
	  };
	
	  _class.prototype.toggleMenu = function toggleMenu() {
	    this.setState({ menuOpen: !this.state.menuOpen });
	  };
	
	  _class.prototype.handleScroll = function handleScroll() {
	    var state = this.state;
	
	    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
	
	    if (!state.scrolled && scrollTop > 0) {
	      this.setState({ scrolled: true });
	    } else if (state.scrolled && scrollTop === 0) {
	      this.setState({ scrolled: false });
	    }
	  };
	
	  _class.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener('scroll', this.handleScroll);
	  };
	
	  _class.prototype.render = function render() {
	    var _this2 = this;
	
	    var props = this.props,
	        state = this.state;
	    var data = props.data,
	        children = props.children;
	
	
	    var stylesLayout = [_indexModule2.default.layout, state.menuOpen ? _indexModule2.default.layoutMenu : ''].join(' ');
	
	    return _react2.default.createElement(
	      'div',
	      { className: stylesLayout },
	      _react2.default.createElement(
	        'div',
	        { className: state.scrolled ? [_indexModule2.default.topNav, _indexModule2.default.topNavScrolled].join(' ') : _indexModule2.default.topNav },
	        _react2.default.createElement(
	          'div',
	          { className: ['row', 'collapse', 'align-middle', _indexModule2.default.topNavRow].join(' ') },
	          _react2.default.createElement(
	            'div',
	            { className: 'small-3 columns' },
	            _react2.default.createElement(
	              'button',
	              { className: 'hamburger', type: 'button', onClick: function onClick() {
	                  return _this2.toggleMenu();
	                } },
	              _react2.default.createElement(
	                'span',
	                { className: 'hamburger-box' },
	                _react2.default.createElement('span', { className: 'hamburger-inner' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'small-6 columns text-center' },
	            _react2.default.createElement(
	              'h2',
	              { className: _indexModule2.default.siteTitleHeader },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/', className: _indexModule2.default.siteTitle },
	                _config.siteTitle
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'medium-3 columns show-for-medium text-right' },
	            _react2.default.createElement(_social2.default, { socialMedia: data.contentfulLayout.socialMedia })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _indexModule2.default.nav },
	        _react2.default.createElement(
	          'div',
	          { className: _indexModule2.default.navWrapper },
	          _react2.default.createElement(
	            'div',
	            { className: _indexModule2.default.navContainer },
	            _react2.default.createElement(
	              'button',
	              { className: 'hamburger hamburger--boring is-active', type: 'button', onClick: function onClick() {
	                  return _this2.toggleMenu();
	                } },
	              _react2.default.createElement(
	                'span',
	                { className: 'hamburger-box' },
	                _react2.default.createElement('span', { className: 'hamburger-inner' })
	              )
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: _indexModule2.default.navList },
	              data.contentfulLayout.navigation.map(function (item, index) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: index },
	                  item.url.startsWith('/') ? _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: item.url, className: _indexModule2.default.navLink, onClick: function onClick() {
	                        return _this2.closeMenu();
	                      } },
	                    item.title
	                  ) : _react2.default.createElement(
	                    'a',
	                    { href: item.url, className: _indexModule2.default.navLink, onClick: function onClick() {
	                        return _this2.closeMenu();
	                      } },
	                    item.title
	                  )
	                );
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'show-for-small-only' },
	              _react2.default.createElement(_social2.default, { socialMedia: data.contentfulLayout.socialMedia })
	            )
	          )
	        ),
	        _react2.default.createElement('div', { className: _indexModule2.default.navShade, onClick: function onClick() {
	            return _this2.closeMenu();
	          } })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _indexModule2.default.main },
	        children()
	      )
	    );
	  };
	
	  return _class;
	}(_react.Component);
	
	exports.default = _class;
	;
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 348:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"row":"src-layouts----index-module---row---x5RfZ","collapse":"src-layouts----index-module---collapse---2XKDf","expanded":"src-layouts----index-module---expanded---1M40m","column":"src-layouts----index-module---column---1JUT5","columns":"src-layouts----index-module---columns---2B78T","is-collapse-child":"src-layouts----index-module---is-collapse-child---1LZuR","small-1":"src-layouts----index-module---small-1---1b-KH","small-offset-0":"src-layouts----index-module---small-offset-0---JEiYT","small-2":"src-layouts----index-module---small-2---S-Y_g","small-offset-1":"src-layouts----index-module---small-offset-1---2G2Sm","small-3":"src-layouts----index-module---small-3---DEn6t","small-offset-2":"src-layouts----index-module---small-offset-2---7T7kb","small-4":"src-layouts----index-module---small-4---3NhpZ","small-offset-3":"src-layouts----index-module---small-offset-3---2YYcf","small-5":"src-layouts----index-module---small-5---3zqZI","small-offset-4":"src-layouts----index-module---small-offset-4---wyCoo","small-6":"src-layouts----index-module---small-6---3475k","small-offset-5":"src-layouts----index-module---small-offset-5---1NQWP","small-7":"src-layouts----index-module---small-7---1i-5S","small-offset-6":"src-layouts----index-module---small-offset-6---1nS15","small-8":"src-layouts----index-module---small-8---1XV3g","small-offset-7":"src-layouts----index-module---small-offset-7---1va5l","small-9":"src-layouts----index-module---small-9---2IjnQ","small-offset-8":"src-layouts----index-module---small-offset-8---H4_Jb","small-10":"src-layouts----index-module---small-10---3adPk","small-offset-9":"src-layouts----index-module---small-offset-9---1xtsL","small-11":"src-layouts----index-module---small-11---1Pjol","small-offset-10":"src-layouts----index-module---small-offset-10---2CEJ7","small-12":"src-layouts----index-module---small-12---2M0mv","small-offset-11":"src-layouts----index-module---small-offset-11---2k9aA","small-up-1":"src-layouts----index-module---small-up-1---1NOM-","small-up-2":"src-layouts----index-module---small-up-2---OW_Nh","small-up-3":"src-layouts----index-module---small-up-3---3K9PO","small-up-4":"src-layouts----index-module---small-up-4---OAQ35","small-up-5":"src-layouts----index-module---small-up-5---3E5-k","small-up-6":"src-layouts----index-module---small-up-6---3N_-q","small-up-7":"src-layouts----index-module---small-up-7---zj5Rm","small-up-8":"src-layouts----index-module---small-up-8---3csZC","small-collapse":"src-layouts----index-module---small-collapse---30tPs","small-uncollapse":"src-layouts----index-module---small-uncollapse---3i1C7","medium-1":"src-layouts----index-module---medium-1---2zd1M","medium-offset-0":"src-layouts----index-module---medium-offset-0---16yX4","medium-2":"src-layouts----index-module---medium-2---J7nCP","medium-offset-1":"src-layouts----index-module---medium-offset-1---20ODY","medium-3":"src-layouts----index-module---medium-3---HMDKG","medium-offset-2":"src-layouts----index-module---medium-offset-2---gTeIf","medium-4":"src-layouts----index-module---medium-4---3mA80","medium-offset-3":"src-layouts----index-module---medium-offset-3---2ai1P","medium-5":"src-layouts----index-module---medium-5---2WJuG","medium-offset-4":"src-layouts----index-module---medium-offset-4---au2n0","medium-6":"src-layouts----index-module---medium-6---3w_jW","medium-offset-5":"src-layouts----index-module---medium-offset-5---3wG-K","medium-7":"src-layouts----index-module---medium-7---1ajlq","medium-offset-6":"src-layouts----index-module---medium-offset-6---1yo1M","medium-8":"src-layouts----index-module---medium-8---3STf2","medium-offset-7":"src-layouts----index-module---medium-offset-7---1UgqK","medium-9":"src-layouts----index-module---medium-9---1rrYJ","medium-offset-8":"src-layouts----index-module---medium-offset-8---2_idZ","medium-10":"src-layouts----index-module---medium-10---1SOXO","medium-offset-9":"src-layouts----index-module---medium-offset-9---3_F5B","medium-11":"src-layouts----index-module---medium-11---2v6h5","medium-offset-10":"src-layouts----index-module---medium-offset-10---35gG3","medium-12":"src-layouts----index-module---medium-12---UDBfU","medium-offset-11":"src-layouts----index-module---medium-offset-11---1YbAW","medium-up-1":"src-layouts----index-module---medium-up-1---28Mdt","medium-up-2":"src-layouts----index-module---medium-up-2---1Ct5b","medium-up-3":"src-layouts----index-module---medium-up-3---1vavY","medium-up-4":"src-layouts----index-module---medium-up-4---3Z-6x","medium-up-5":"src-layouts----index-module---medium-up-5---3EaEW","medium-up-6":"src-layouts----index-module---medium-up-6---2prIX","medium-up-7":"src-layouts----index-module---medium-up-7---aLCxM","medium-up-8":"src-layouts----index-module---medium-up-8---24l4m","medium-expand":"src-layouts----index-module---medium-expand---1svdJ","medium-unstack":"src-layouts----index-module---medium-unstack---2Cegw","medium-collapse":"src-layouts----index-module---medium-collapse---2MEpX","medium-uncollapse":"src-layouts----index-module---medium-uncollapse---1zIsW","large-1":"src-layouts----index-module---large-1---2rluU","large-offset-0":"src-layouts----index-module---large-offset-0---3m1Yi","large-2":"src-layouts----index-module---large-2---3ZIBW","large-offset-1":"src-layouts----index-module---large-offset-1---QI7QZ","large-3":"src-layouts----index-module---large-3---pV1VW","large-offset-2":"src-layouts----index-module---large-offset-2---36xah","large-4":"src-layouts----index-module---large-4---IdU9I","large-offset-3":"src-layouts----index-module---large-offset-3---ojXNH","large-5":"src-layouts----index-module---large-5---3tD3t","large-offset-4":"src-layouts----index-module---large-offset-4---FMQEy","large-6":"src-layouts----index-module---large-6---21CAy","large-offset-5":"src-layouts----index-module---large-offset-5---2Q4fp","large-7":"src-layouts----index-module---large-7---2_Q2T","large-offset-6":"src-layouts----index-module---large-offset-6---2UXTc","large-8":"src-layouts----index-module---large-8---3EgF1","large-offset-7":"src-layouts----index-module---large-offset-7---17BTs","large-9":"src-layouts----index-module---large-9---3uM5Q","large-offset-8":"src-layouts----index-module---large-offset-8---Ldpfs","large-10":"src-layouts----index-module---large-10---DhJ7i","large-offset-9":"src-layouts----index-module---large-offset-9---qL7_b","large-11":"src-layouts----index-module---large-11---2VAGJ","large-offset-10":"src-layouts----index-module---large-offset-10---FymTx","large-12":"src-layouts----index-module---large-12---1zcO8","large-offset-11":"src-layouts----index-module---large-offset-11---3a5Y0","large-up-1":"src-layouts----index-module---large-up-1---3USAF","large-up-2":"src-layouts----index-module---large-up-2---3LbB-","large-up-3":"src-layouts----index-module---large-up-3---2sLNl","large-up-4":"src-layouts----index-module---large-up-4---3PwHd","large-up-5":"src-layouts----index-module---large-up-5---2ya0-","large-up-6":"src-layouts----index-module---large-up-6---22IOT","large-up-7":"src-layouts----index-module---large-up-7---34XkE","large-up-8":"src-layouts----index-module---large-up-8---1iEZ-","large-expand":"src-layouts----index-module---large-expand---1vzis","large-unstack":"src-layouts----index-module---large-unstack---3xoLx","large-collapse":"src-layouts----index-module---large-collapse---9KGGV","large-uncollapse":"src-layouts----index-module---large-uncollapse---1-57d","shrink":"src-layouts----index-module---shrink---ijYsu","column-block":"src-layouts----index-module---column-block---2l-KQ","hide":"src-layouts----index-module---hide---3xsLt","invisible":"src-layouts----index-module---invisible---JOdB1","hide-for-small-only":"src-layouts----index-module---hide-for-small-only---1rWYw","show-for-small-only":"src-layouts----index-module---show-for-small-only---mNoSI","hide-for-medium":"src-layouts----index-module---hide-for-medium---2CXKz","show-for-medium":"src-layouts----index-module---show-for-medium---1qlEW","hide-for-medium-only":"src-layouts----index-module---hide-for-medium-only---1b6Rg","show-for-medium-only":"src-layouts----index-module---show-for-medium-only---30kyQ","hide-for-large":"src-layouts----index-module---hide-for-large---363Uo","show-for-large":"src-layouts----index-module---show-for-large---1tRMr","hide-for-large-only":"src-layouts----index-module---hide-for-large-only---3khP3","show-for-large-only":"src-layouts----index-module---show-for-large-only---1tobh","show-for-sr":"src-layouts----index-module---show-for-sr---3ciWg","show-on-focus":"src-layouts----index-module---show-on-focus---3siLU","show-for-landscape":"src-layouts----index-module---show-for-landscape---uixNF","hide-for-portrait":"src-layouts----index-module---hide-for-portrait---OVhho","hide-for-landscape":"src-layouts----index-module---hide-for-landscape---2OEGD","show-for-portrait":"src-layouts----index-module---show-for-portrait---3X0jP","align-left":"src-layouts----index-module---align-left---2nuNk","align-right":"src-layouts----index-module---align-right---2iC4o","align-center":"src-layouts----index-module---align-center---QlLub","align-justify":"src-layouts----index-module---align-justify---1MGPl","align-spaced":"src-layouts----index-module---align-spaced---1RUBO","vertical":"src-layouts----index-module---vertical---2_Anu","menu":"src-layouts----index-module---menu---oUYJS","align-top":"src-layouts----index-module---align-top---3R-HL","align-self-top":"src-layouts----index-module---align-self-top---3vq-b","align-bottom":"src-layouts----index-module---align-bottom---1r4Ii","align-self-bottom":"src-layouts----index-module---align-self-bottom---3w8dT","align-middle":"src-layouts----index-module---align-middle---1IdIi","align-self-middle":"src-layouts----index-module---align-self-middle---1K6q2","align-stretch":"src-layouts----index-module---align-stretch---3Blra","align-self-stretch":"src-layouts----index-module---align-self-stretch---mEBIQ","align-center-middle":"src-layouts----index-module---align-center-middle---3Wg0X","small-order-1":"src-layouts----index-module---small-order-1---3w5A7","small-order-2":"src-layouts----index-module---small-order-2---2vWpJ","small-order-3":"src-layouts----index-module---small-order-3---1PBQu","small-order-4":"src-layouts----index-module---small-order-4---3a3Ug","small-order-5":"src-layouts----index-module---small-order-5---2bM51","small-order-6":"src-layouts----index-module---small-order-6---2jqsl","medium-order-1":"src-layouts----index-module---medium-order-1---2z5Py","medium-order-2":"src-layouts----index-module---medium-order-2---27cz1","medium-order-3":"src-layouts----index-module---medium-order-3---17UUx","medium-order-4":"src-layouts----index-module---medium-order-4---1EIod","medium-order-5":"src-layouts----index-module---medium-order-5---1FzsM","medium-order-6":"src-layouts----index-module---medium-order-6---3BZgP","large-order-1":"src-layouts----index-module---large-order-1---12-Ch","large-order-2":"src-layouts----index-module---large-order-2---3EO2M","large-order-3":"src-layouts----index-module---large-order-3---Yon8D","large-order-4":"src-layouts----index-module---large-order-4---2ZyFC","large-order-5":"src-layouts----index-module---large-order-5---1eLdS","large-order-6":"src-layouts----index-module---large-order-6---agegu","flex-container":"src-layouts----index-module---flex-container---3gdfp","flex-child-auto":"src-layouts----index-module---flex-child-auto---3MRe_","flex-child-grow":"src-layouts----index-module---flex-child-grow---3KSw_","flex-child-shrink":"src-layouts----index-module---flex-child-shrink---3HQBZ","flex-dir-row":"src-layouts----index-module---flex-dir-row---PcMAC","flex-dir-row-reverse":"src-layouts----index-module---flex-dir-row-reverse---1OPjm","flex-dir-column":"src-layouts----index-module---flex-dir-column---3sD9D","flex-dir-column-reverse":"src-layouts----index-module---flex-dir-column-reverse---3aCBa","medium-flex-container":"src-layouts----index-module---medium-flex-container---D_yjU","medium-flex-child-auto":"src-layouts----index-module---medium-flex-child-auto---1lcty","medium-flex-child-grow":"src-layouts----index-module---medium-flex-child-grow---1Gx3S","medium-flex-child-shrink":"src-layouts----index-module---medium-flex-child-shrink---3p_c3","medium-flex-dir-row":"src-layouts----index-module---medium-flex-dir-row---2lWXV","medium-flex-dir-row-reverse":"src-layouts----index-module---medium-flex-dir-row-reverse---1hdfQ","medium-flex-dir-column":"src-layouts----index-module---medium-flex-dir-column---1gC3D","medium-flex-dir-column-reverse":"src-layouts----index-module---medium-flex-dir-column-reverse---2tAJW","large-flex-container":"src-layouts----index-module---large-flex-container---j0YZ2","large-flex-child-auto":"src-layouts----index-module---large-flex-child-auto---2Mn8T","large-flex-child-grow":"src-layouts----index-module---large-flex-child-grow---1vjsW","large-flex-child-shrink":"src-layouts----index-module---large-flex-child-shrink---3TKAK","large-flex-dir-row":"src-layouts----index-module---large-flex-dir-row---wiOk1","large-flex-dir-row-reverse":"src-layouts----index-module---large-flex-dir-row-reverse---35ZjB","large-flex-dir-column":"src-layouts----index-module---large-flex-dir-column---oXUJt","large-flex-dir-column-reverse":"src-layouts----index-module---large-flex-dir-column-reverse---2YvzU","text-left":"src-layouts----index-module---text-left---1K16u","text-right":"src-layouts----index-module---text-right---2qA2q","text-center":"src-layouts----index-module---text-center---1N4jg","text-justify":"src-layouts----index-module---text-justify---38inc","medium-text-left":"src-layouts----index-module---medium-text-left---1b5Vw","medium-text-right":"src-layouts----index-module---medium-text-right---2qHD2","medium-text-center":"src-layouts----index-module---medium-text-center---orwx1","medium-text-justify":"src-layouts----index-module---medium-text-justify---G1B98","large-text-left":"src-layouts----index-module---large-text-left---2lsPg","large-text-right":"src-layouts----index-module---large-text-right---MFqK_","large-text-center":"src-layouts----index-module---large-text-center---2zvlR","large-text-justify":"src-layouts----index-module---large-text-justify---17vcC","layout":"src-layouts----index-module---layout---3KUdE","layoutMenu":"src-layouts----index-module---layoutMenu---2bdey","nav":"src-layouts----index-module---nav---2YwUj","navWrapper":"src-layouts----index-module---navWrapper---vdqRX","navShade":"src-layouts----index-module---navShade---3cPz4","main":"src-layouts----index-module---main---9FDcp","topNav":"src-layouts----index-module---topNav---2I-o4","topNavScrolled":"src-layouts----index-module---topNavScrolled---14lau","siteTitleHeader":"src-layouts----index-module---siteTitleHeader---3xF7_","siteTitle":"src-layouts----index-module---siteTitle---12di_","topNavRow":"src-layouts----index-module---topNavRow---3tul4","navContainer":"src-layouts----index-module---navContainer---BmxQk","navList":"src-layouts----index-module---navList---2Ak-p","navLink":"src-layouts----index-module---navLink---102IZ"};

/***/ }),

/***/ 350:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 500:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 501:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-3cf38ab3af0694f79a4d.js